export default Object.freeze({
  DispenseSAEEProviderRequest: 1,
  DispenseSAEESpecialistRequest: 2,
  EthicDeterminationLetter: 3,
});
